<!-- This template displays the overlay content and is connected to the button -->
<avano-popover #op styleClass="notifications-popover">
  <avano-notifications-header [unread]="unread$ | async" (unreadChange)="toggleUnread($event)"></avano-notifications-header>
  <avano-notifications-item
    *ngFor="let notification of notifications$ | async"
    [notification]="notification"
    (markAsRead)="markAsRead($event)"
    (deleteOne)="delete($event)"
    (downloadReport)="downloadReport($event)"
  ></avano-notifications-item>
</avano-popover>

<ng-container
  *ngIf="{
    unreadCount: unreadCount$ | async
  } as data"
>
  <avano-avano-appheader-icon
    [class.hidden]="data.unreadCount === 0"
    pBadge
    [value]="'' + data.unreadCount"
    (click)="op.toggle($event)"
    type="button"
    icon="icon-header-notification"
  ></avano-avano-appheader-icon>
</ng-container>
